import {
  FETCH_JOURNALS,
  FETCH_JOURNAL,
  CREATE_JOURNAL,
  UPDATE_JOURNAL,
  DELETE_JOURNAL,
  FETCH_JOURNAL_SUMMARY,
  FETCH_JOURNAL_ENTRIES,
  FETCH_JOURNAL_ENTRY,
  CREATE_JOURNAL_ENTRY,
  UPDATE_JOURNAL_ENTRY,
  DELETE_JOURNAL_ENTRY,
  SUBMIT_JOURNAL_ENTRY,
  APPROVE_JOURNAL_ENTRY,
  POST_JOURNAL_ENTRY,
  REVERSE_JOURNAL_ENTRY,
  BULK_APPROVE_ENTRIES,
  BULK_POST_ENTRIES,
  START_LOADING,
  END_LOADING,
  JOURNALS_ERROR,
  CLEAR_JOURNALS_ERROR
} from '../actions/constants';

const initialState = {
  journals: [],
  currentJournal: null,
  journalSummary: null,
  journalEntries: [],
  currentJournalEntry: null,
  journalAccounts: [],
  totalPages: 0,
  currentPage: 1,
  totalEntries: 0,
  loading: false,
  error: null
};

const journalsReducer = (state = initialState, action) => {
  switch (action.type) {
    // Journal Management
    case FETCH_JOURNALS:
      return {
        ...state,
        journals: action.payload.data || action.payload.journals || action.payload || [],
        totalPages: action.payload.totalPages || 1,
        currentPage: action.payload.currentPage || 1
      };

    case FETCH_JOURNAL:
      return {
        ...state,
        currentJournal: action.payload.data || action.payload
      };

    case CREATE_JOURNAL:
      return {
        ...state,
        journals: [action.payload, ...state.journals]
      };

    case UPDATE_JOURNAL:
      return {
        ...state,
        journals: state.journals.map(journal =>
          journal._id === action.payload._id ? action.payload : journal
        ),
        currentJournal: state.currentJournal?._id === action.payload._id 
          ? action.payload 
          : state.currentJournal
      };

    case DELETE_JOURNAL:
      return {
        ...state,
        journals: state.journals.filter(journal => journal._id !== action.payload),
        currentJournal: state.currentJournal?._id === action.payload 
          ? null 
          : state.currentJournal
      };

    case FETCH_JOURNAL_SUMMARY:
      return {
        ...state,
        journalSummary: action.payload.data || action.payload
      };
      
    // Journal Entries
    case FETCH_JOURNAL_ENTRIES:
      return {
        ...state,
        journalEntries: action.payload.data || action.payload.entries || action.payload || [],
        totalPages: action.payload.totalPages || 1,
        currentPage: action.payload.currentPage || 1,
        totalEntries: action.payload.totalEntries || (action.payload.data ? action.payload.data.length : action.payload.length)
      };

    case FETCH_JOURNAL_ENTRY:
      return {
        ...state,
        currentJournalEntry: action.payload.data || action.payload
      };

    case CREATE_JOURNAL_ENTRY:
      return {
        ...state,
        journalEntries: [action.payload, ...state.journalEntries]
      };

    case UPDATE_JOURNAL_ENTRY:
    case SUBMIT_JOURNAL_ENTRY:
    case APPROVE_JOURNAL_ENTRY:
    case POST_JOURNAL_ENTRY:
    case REVERSE_JOURNAL_ENTRY:
      return {
        ...state,
        journalEntries: state.journalEntries.map(entry =>
          entry._id === action.payload._id ? action.payload : entry
        ),
        currentJournalEntry: state.currentJournalEntry?._id === action.payload._id 
          ? action.payload 
          : state.currentJournalEntry
      };

    case DELETE_JOURNAL_ENTRY:
      return {
        ...state,
        journalEntries: state.journalEntries.filter(entry => entry._id !== action.payload),
        currentJournalEntry: state.currentJournalEntry?._id === action.payload 
          ? null 
          : state.currentJournalEntry
      };

    case BULK_APPROVE_ENTRIES:
    case BULK_POST_ENTRIES:
      return {
        ...state,
        journalEntries: state.journalEntries.map(entry => {
          const updatedEntry = action.payload.find(updated => updated._id === entry._id);
          return updatedEntry || entry;
        })
      };

    case START_LOADING:
      return {
        ...state,
        loading: true,
        error: null
      };

    case END_LOADING:
      return {
        ...state,
        loading: false
      };

    case JOURNALS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      };

    case CLEAR_JOURNALS_ERROR:
      return {
        ...state,
        error: null
      };

    default:
      return state;
  }
};

export default journalsReducer;
